import { FC, ReactNode } from "react";
import { TbHelpCircle } from "react-icons/tb";
import { LogoIcon } from "../../../assets/svg";

interface Prop {
  children: ReactNode;
}

export const EnterpriseAuthContainer: FC<Prop> = ({ children }) => {
  return (
    <div className="w-full h-screen overflow-y-auto md:w-1/2 flex flex-col justify-between bg-white p-4 md:p-5 lg:p-8">
      <div className="flex flex-1 flex-col">
        <img src={LogoIcon} alt="Company Logo" className="h-8 w-20 shrink-0" />

        <div className="m-auto flex w-full max-w-[437px] flex-col gap-4 py-8">
          {children}
        </div>
      </div>
      <footer className="flex items-center gap-1 text-base font-medium font-satoshi text-center lg:text-left text-bash mt-4 pt-4">
        <TbHelpCircle />
        <p>
          Got any questions?{" "}
          <a
            href="https://www.buildwithbnkle.com/contact"
            target="blank"
            className="text-bblue hover:underline"
          >
            Contact Us
          </a>
        </p>
      </footer>
    </div>
  );
};
